import React, { useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import { Box, Button, Chip, Stack } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import GlobalDatagrid from '../../../../components/mui/DataGrid/GlobalDatagrid';
import ActionDetails from '../../../../components/mui/GlobalAnchor/ActionDetails';
import GlobalAnchorList from '../../../../components/mui/GlobalAnchor/GlobalAnchorList';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { deleteTopic, getSmeLeads, getSmeSchedules } from '../../../../redux/features/smeSlice';
import { SME_TOPIC_SCHEDULES_HEAD } from '../../../../components/datagrid/sme/smeSchedulesTableHead';
import AddSchedule from './AddSchedule';
import UpdateSmeSchedule from './UpdateSmeSchedule';
import { useLocation } from 'react-router-dom';
import DeleteTopic from './DeleteSchedule';
import { savePaginationData } from '../../../../redux/features/globalDatagridSlice';
import { getAddedTopics, getSubjectsUnderBatchId } from '../../../../redux/features/batchSlice';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import GlobalDeleteDialogueContent from '../../../../components/GlobalDeleteDialogueContent';
import { isSameUserType } from '../../../../utils/helperFunction';
import { croTypeNames } from '../../../../utils/employeeTypes';

const SMESchedules = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const courseenrollmentId = searchParams.get('courseenrollmentId');
  const studentname = searchParams.get('studentname');
  const phone = searchParams.get('phone');
  const course = searchParams.get('course');
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, checkedRowsIds, search } = paginationData;
  const { smeTopicSchedules, loading } = useSelector((state) => state.sme);
  const { addedTopics } = useSelector((state) => state.batch);
  const BatchID = searchParams.get('BatchID');
  const [refresh, setRefresh] = useState(false);
  const [bulkModal, setBulkModal] = useState(false);

  const { batchDetails } = location.state || {};
  const isCro = useMemo(() => {
    const role = JSON.parse(localStorage.getItem('cred'))?.profile?.role;
    return isSameUserType({ roleArray: croTypeNames, role });
  }, []);

  const [value, setValue] = useState(dayjs());

  const data = {
    page: pageNum,
    limit: gridSize,
    filter: search,
    status: 0,
    course_enrollment_id: courseenrollmentId,
  };

  useEffect(() => {
    if (pageNum && gridSize && !BatchID) {
      dispatch(
        savePaginationData({
          ...paginationData,
          openAnchor: false,
        }),
      );
      dispatch(getSmeSchedules(data));
    }
  }, [pageNum, gridSize, search, refresh]);

  const dataParams = {
    batch_id: BatchID,
    page: pageNum,
    limit: gridSize,
    search: search,
  };

  useEffect(() => {
    if (BatchID && pageNum && gridSize) {
      dispatch(getAddedTopics(dataParams));
    }
  }, [BatchID, pageNum, gridSize, search, refresh]);

  return (
    <GlobalWrapper
      title={'SME Schedules'}
      actions={
        <AddSchedule
          dispatchdata={data}
          courseenrollmentId={courseenrollmentId}
          BatchID={BatchID}
          dataParams={dataParams}
        />
      }
    >
      <Stack py={1}>
        <Button
          variant="contained"
          sx={{ alignSelf: 'flex-end' }}
          disabled={!Boolean(checkedRowsIds?.length)}
          onClick={() => setBulkModal(true)}
        >
          Bulk Delete
        </Button>
      </Stack>
      {BatchID && (
        <Stack
          direction={{
            xs: 'column',
            sm: 'row',
          }}
          spacing={1}
          sx={{ marginBottom: 2 }}
        >
          <Chip label={`Batch : ${batchDetails?.course_batch_name}`} variant="filled" color="secondary" size="medium" />
          <Chip label={`Course : ${batchDetails?.courseAvailable}`} variant="filled" color="secondary" size="medium" />
          <Chip label={`Class : ${batchDetails?.className}`} variant="filled" color="secondary" size="medium" />
          <Chip label={`Syllabus : ${batchDetails?.syllabusName}`} variant="filled" color="secondary" size="medium" />
          <Chip
            label={`Capacity : ${batchDetails?.course_batch_capacity}`}
            variant="filled"
            color="secondary"
            size="medium"
          />
        </Stack>
      )}
      {!BatchID && (
        <Stack
          direction={{
            xs: 'column',
            sm: 'row',
          }}
          spacing={1}
          sx={{ marginBottom: 2 }}
        >
          <Box
            sx={{
              backgroundImage: 'linear-gradient(to right,#1E91D6,#141B41)',
              px: '20px',
              py: '10px',
              borderRadius: '15px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '16px',
            }}
          >
            Name : {studentname}
          </Box>
          <Box
            sx={{
              backgroundImage: 'linear-gradient(to right,#1E91D6,#141B41)',
              px: '20px',
              py: '10px',
              borderRadius: '15px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '16px',
            }}
          >
            Phone Number : {phone}
          </Box>
          <Box
            sx={{
              backgroundImage: 'linear-gradient(to right,#1E91D6,#141B41)',
              px: '20px',
              py: '10px',
              borderRadius: '15px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '16px',
            }}
          >
            Course : {course}
          </Box>
        </Stack>
      )}
      <Box sx={{ width: '100%', padding: 0 }}>
        <GlobalDialog
          title={'Delete Topic'}
          open={bulkModal}
          closeButton
          setOpen={setBulkModal}
          content={
            <GlobalDeleteDialogueContent
              content={'Are you sure? you want to delete this schedule topic..?'}
              deleteDispatchParams={{ sme_schedules_topic_ids: checkedRowsIds }}
              dispatchDeleteFn={deleteTopic}
              loading={loading}
              onSuccessDispatchFn={() => {
                setRefresh((prev) => !prev);
                setBulkModal(false);
              }}
            />
          }
        />
        <GlobalDatagrid
          tableHead={SME_TOPIC_SCHEDULES_HEAD}
          rows={BatchID ? addedTopics.data || [] : smeTopicSchedules.data || []}
          meta={BatchID ? addedTopics?.meta?.totalRecords || 0 : smeTopicSchedules?.meta?.totalRecords || 0}
          rowUniqueId="sme_schedules_topic_id"
          getRowClassName={(params) => {
            if (params?.row?.session_schedule_id !== null) {
              return 'green-row';
            }
            return '';
          }}
          sx={{
            '& .green-row': {
              backgroundColor: '#90EE90 !important',
            },
            '& .green-row:hover': {
              backgroundColor: '#7CCD7C !important',
            },
          }}
          loading={loading}
          checkboxSelection={isCro ? false : true}
          disableSelectionOnClick
          rowClick={isCro ? false : true}
          actionComponent={
            <>
              <ActionDetails val={rowData?.chapter} />
              <GlobalAnchorList
                component={<UpdateSmeSchedule rowData={rowData} leadId={courseenrollmentId} dispatchdata={data} />}
                label=""
              />
              <GlobalAnchorList
                component={<DeleteTopic rowData={rowData} id={rowData?.sme_schedules_topic_id} data={data} />}
                label=""
              />
            </>
          }
        />
      </Box>
    </GlobalWrapper>
  );
};

export default SMESchedules;
